import * as React from "react";
import {MaskedInput} from "./MaskedInput";
import update = require("react-addons-update");
const { detect } = require('detect-browser');
const browser = detect();
export interface TextBoxProps
{
	fieldName: string;
	label?: string;
	placeholder?: string;
	tooltip?: string;
	inputClassName?: string;
	type?: "text" | "number" | "email" | "date" | "datetime" | "datetime-local" | "month" | "password" | "search" | "tel" |
	"url" | "week";
	mask?: string;
	defaultValue?: string;
	onBlur?: (event: React.FormEvent<any>) => void;
	onChange?: (event: React.FormEvent<any>) => void;
	value?: string;
	isRequired?: boolean;
	requiredMessage?: string;
	inputRef?: any;
	min?: any;
}

export interface TextBoxState
{
	value?: string;
}

export class TextBox extends React.Component<TextBoxProps, TextBoxState>
{
	state: TextBoxState = {};

	componentWillMount()
	{
		this.state.value = this.props.value;
	}

	componentWillReceiveProps(nextProps: TextBoxProps)
	{
		//IMPORTANT-
		//we must have a value set in props (at least empty string) in order to set state via props in this lifecycle method 
		//Without this, we can't clear a textbox after content is submitted 
		//and textboxes whose parents don't track value will reset this component's value back to nothing on every key stroke
		//see - CreditCardPayment, that component does not track value for each textbox, so this call will reset state to nothing
		if ((nextProps.value !== undefined && nextProps.value !== null) && nextProps.value !== this.state.value)
			this.setState(update(this.state, { $set: { value: nextProps.value } }));
	}

	render()
	{
		const input = this.getInput();
		return <div className="form-group" title={this.props.tooltip}>
			<label htmlFor={this.props.fieldName}>{this.props.label}</label>
			{input}
			{this.getRequiredMessage() }
		</div>;
	}

	private getRequiredMessage()
	{
		if (!this.props.isRequired)
		{
			return null;
		}
		if (this.state.value === null || this.state.value === undefined)
		{
			return this.getRequiredMessageInternal();
		}
		if (this.state.value !== null && this.state.value !== undefined)
		{
			if (this.state.value.trim().length === 0)
			{
				return this.getRequiredMessageInternal();
			}
		}
		return null;
	}

	private getRequiredMessageInternal()
	{
		return <span className="text-danger bg-danger">{this.props.requiredMessage || "Required"}</span>;
	}

	private getInput()
	{
		const className = this.props.inputClassName ? this.props.inputClassName : "";
		if (this.props.mask && !this.isMobileAndroid())
		{
			return <MaskedInput
				className={`form-control ${className}`}
				id={this.props.fieldName}
				name={this.props.fieldName}
				mask={this.props.mask}
				value={this.state.value}
				placeholder={this.props.placeholder}
				onChange={this.updateStateChange.bind(this) }
				type={this.props.type}
				//onBlur={this.blurStateChange.bind(this)}
				/>;
		}
		if (browser && browser.name)
		{
			if( browser.name === "ie" && browser.version === "11.0.0")
			{
			return <input
				className={`form-control ${className}`}
				id={this.props.fieldName}
				name={ this.props.fieldName }
				value={this.state.value}
				placeholder={this.props.placeholder}
				type={this.props.type}
				onInput={this.updateStateChange.bind(this) }
				onBlur={this.blurStateChange.bind(this) }
				ref={this.props.inputRef}
				min={this.props.min}
				/>;
			}
		}
		return <input
			className={`form-control ${className}`}
			id={this.props.fieldName}
			name={ this.props.fieldName }
			value={this.state.value}
			placeholder={this.props.placeholder}
			type={this.props.type}
			onChange={this.updateStateChange.bind(this) }
			onBlur={this.blurStateChange.bind(this) }
			ref={this.props.inputRef}
			min={this.props.min}
			/>;
	}

	private isMobileAndroid()
	{
		var platform = navigator.platform.toLocaleLowerCase();
		if (platform.indexOf("android") !== -1 || platform.indexOf("linux") !== -1 || platform === null)
			return true;

		return false;
	}

	private updateStateChange(ev: React.FormEvent<any>)
	{
		this.setState(update(this.state, { $set: { value: ev.target.value } }));
		if (this.props.onChange)
		{
			this.props.onChange(ev);
		}
	}

	private blurStateChange(ev: React.FormEvent<any>)
	{
		this.setState(update(this.state, { $set: { value: ev.target.value } }));
		if (this.props.onBlur)
		{
			this.props.onBlur(ev);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/common/TextBox.tsx